import React, { useState, useCallback, useRef, useEffect } from 'react';

function Correct({ dir, answer, root, level, number, isLast, correct, correctNumber, correctText, correctNote, onClick }) {
  const wrapperRef = useRef();
  const onClose = useCallback(() => {
    root.dataset.status = 'hide';
    root.dispatchEvent(
      new CustomEvent('ended', {
        detail: {
          level: level + 1,
          number: number + 1,
        },
      })
    );
  }, []);

  const _answer = answer.replace('$dir/', dir);
  let button;
  if (!isLast) {
    button = (
      <button onTouchStart={() => {}} className="questionBtn questionSearchBtn" onClick={onClose}>
        <img src={dir + 'assets/img/btn-search.png'} alt="植物を探す" />
      </button>
    );
  } else {
    button = (
      <button
        onTouchStart={() => {}}
        className={'questionBtn questionNextBtn2 btn-' + Number(number + 1)}
        onClick={() => {
          onClick(6);
        }}
      >
        <img src={dir + 'assets/img/btn-next2.png'} alt="次へ" />
      </button>
    );
  }
  let choiceNumber;
  if (correctNumber) {
    choiceNumber = correctNumber;
  } else {
    choiceNumber = Number(correct + 1);
  }
  return (
    <div ref={wrapperRef} className="questionContent questionUseMinDoctor questionCorrect">
      <div className="questionTxt">
        <div className="questionPageTitle questionPageTitleCorrect">
          <img src={dir + 'assets/img/ttl-answer.png'} alt="答え" />
        </div>
        <div className="questionTxtInner correct">
          <div className="questionChoiceBtn questionCorrectBtn">
            <div className="questionChoiceBtnInner">
              <span className="number">
                <img src={dir + 'assets/img/number-choice-' + choiceNumber + '.png'} alt={choiceNumber} className="offBtn" />
              </span>
              <div className={correctNote ? 'txt txt-vertical' : 'txt'}>
                <div dangerouslySetInnerHTML={{ __html: correctText }} />
                {correctNote ? <div dangerouslySetInnerHTML={{ __html: correctNote }} /> : ''}
              </div>
            </div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: _answer }} />
        </div>
        {button}
      </div>
    </div>
  );
}

export default Correct;
